/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Critical_BodyInputs */

const tr_mesafeli_s12_critical_body = /** @type {(inputs: Mesafeli_S12_Critical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mesai saatleri içinde 4 saat, dışında 12 saat.`)
};

const en_mesafeli_s12_critical_body = /** @type {(inputs: Mesafeli_S12_Critical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 hours within business hours, 12 hours outside them.`)
};

const de_mesafeli_s12_critical_body = /** @type {(inputs: Mesafeli_S12_Critical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`innerhalb der Geschäftszeiten 4 Stunden, außerhalb 12 Stunden.`)
};

const ru_mesafeli_s12_critical_body = /** @type {(inputs: Mesafeli_S12_Critical_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 часа в рабочие часы, 12 часов вне рабочих часов.`)
};

/**
* | output |
* | --- |
* | "4 hours within business hours, 12 hours outside them." |
*
* @param {Mesafeli_S12_Critical_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_critical_body = /** @type {((inputs?: Mesafeli_S12_Critical_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Critical_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_critical_body(inputs)
	if (locale === "de") return de_mesafeli_s12_critical_body(inputs)
	if (locale === "ru") return ru_mesafeli_s12_critical_body(inputs)
	return tr_mesafeli_s12_critical_body(inputs)
});